//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import codeJavascript from './code/javascript';
import codeCSS from './code/css';
import codeSCSS from './code/scss';
import codeHTML from './code/html';
export default {
  data: function data() {
    return {
      codeJavascript: codeJavascript,
      codeCSS: codeCSS,
      codeSCSS: codeSCSS,
      codeHTML: codeHTML
    };
  }
};